import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { MensagemCliente } from '../api/dto/mensagem-cliente';

@Injectable({
    providedIn: 'root',
})
export class MensagemClienteService {

    constructor(private http: HttpClient) { }
    private url: string = UrlServidor.URL_BASE + 'mensagens-clientes/';

    buscarPorId(id?: number): Observable<MensagemCliente> {
        return this.http.get<MensagemCliente>(this.url + id);
    }

    listarPorClienteId(clienteId?: number): Observable<MensagemCliente[]> {
        return this.http.get<MensagemCliente[]>(this.url + 'cliente/' + clienteId);
    }

    listarRecadosPrioridadePorClienteId(clienteId?: number): Observable<MensagemCliente[]> {
        return this.http.get<MensagemCliente[]>(this.url + 'cliente/' + clienteId + '/prioridade');
    }

    salvar(mensagem: MensagemCliente): Observable<MensagemCliente> {
        return this.http.post<MensagemCliente>(this.url, mensagem);
    }

    atualizar(id?: number, mensagem?: MensagemCliente): Observable<MensagemCliente> {
        return this.http.put<MensagemCliente>(this.url + id, mensagem);
    }

    alterarStatus(id?: number, novoStatus?: string): Observable<void> {
        return this.http.put<void>(this.url + id + '/alteracao-status', novoStatus);
    }

    alterarCiencia(id?: number, ciencia?: boolean): Observable<void> {
        return this.http.put<void>(this.url + id + '/alteracao-ciencia', ciencia);
    }

    alterarPrioridade(id?: number, prioridade?: boolean): Observable<void> {
        return this.http.put<void>(this.url + id + '/alteracao-prioridade', prioridade);
    }


    excluir(id?: number): Observable<void> {
        return this.http.delete<void>(this.url + id);
    }
}